import { useEffect, useState } from "react";
import { minuteOfDayNow } from "../common/foodMenu";

// One interval for the whole page rather than one per menu card: a menu renders dozens of
// cards, and every one of them needs the same clock to decide whether it is being served
// right now. Subscribers are notified only when the minute actually changes.
const subscribers = new Set();
let currentMinute = minuteOfDayNow();
let timer = null;

const start = () => {
    if (timer !== null) return;
    timer = setInterval(() => {
        const minute = minuteOfDayNow();
        if (minute === currentMinute) return;
        currentMinute = minute;
        subscribers.forEach((notify) => notify(minute));
    }, 15000);
};

const stop = () => {
    if (timer === null || subscribers.size > 0) return;
    clearInterval(timer);
    timer = null;
};

export default function useMinuteOfDay() {
    const [minute, setMinute] = useState(currentMinute);

    useEffect(() => {
        subscribers.add(setMinute);
        start();
        setMinute(minuteOfDayNow());

        return () => {
            subscribers.delete(setMinute);
            stop();
        };
    }, []);

    return minute;
}
